import React from 'react';

import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Text } from 'apps/auth/components/common/Text/Text';
import { LimitBlock } from 'apps/auth/components/profile/gaLimits/LimitBlock';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { toLowerCase } from 'apps/auth/helpers/utils';
import { useApp, useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';

const GaATMLimits = (props) => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const { atmLimits: gaATMLimitsTitle, atmFeeInfo, gaLimitUnlim, ...messages } = usePageMessages();
    const { alarm_limits, atm_limit } = useExtra();

    return (
        <>
            <HeaderPanel title={gaATMLimitsTitle} />
            {atm_limit.unlimited && (
                <Text variant="div" size="header" color="primary">
                    {props.gaLimitUnlim}
                </Text>
            )}
            {atm_limit.active && (
                <LimitBlock
                    title={atmFeeInfo}
                    progressWidth={atm_limit.usedPercent}
                    isExhaustedLimit={alarm_limits <= atm_limit.usedPercent}
                    currency={toLowerCase(atm_limit.cur_iso)}
                    spendSum={getLocalizedRawAmount(lang, country, atm_limit.current_value)}
                    spendText={messages.gaATMLimitStartInfo}
                    leftSum={getLocalizedRawAmount(lang, country, atm_limit.leftValue)}
                    leftText={messages.gaLimitsATMLimitResetLimitInfo}
                />
            )}
        </>
    );
};

export default GaATMLimits;
